<template>
  <div>
    <!-- create dialog -->
    <dialogTemplate :openDialog="isOpen" :widthDialog="isUploading && listCTS.length > 1 ? '900px' : '500px'" :classDialog="'createDialog'" :offsetTop="''"
      @closeDialog="$emit('closeDialog')" @closed="$emit('closed')">
      <template #body>
        <div class="" style=" display: flex ;flex-direction: row; gap: 15px;">
          <div class="" :style="{ width: isUploading && listCTS.length > 1 ? '40%' : '100%' }">
            <h3 class="dialogTitle margin-left-0">Đăng nhập Intrust CA</h3>
            <el-form :model="form" :rules="rules" ref="form" label-position="left" label-width="130px">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="Tài khoản" prop="username">
                    <el-input class="
                    style-fullWidth
                    input-border__bottom input-border__radius__0
                  " v-model="form.username" size="mini" placeholder="-" maxlength="20"
                      @input="oldPasswordError = false">
                    </el-input>
                    <div v-if="oldPasswordError" class="el-form-item__error">
                      Tài khoản hoặc password chưa chính xác!
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="Mật khẩu" prop="password">
                    <el-input class="
                    style-fullWidth
                    input-border__bottom input-border__radius__0
                  " v-model="form.password" size="mini" placeholder="-" maxlength="20" type="password" show-password>
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>

          <div class="ml-9" style="width : 50%" v-if="isUploading && listCTS.length > 1">
            <div style="max-width: 80%; margin: 0 auto;">
              <p class="" style="margin: 20px 0 20px 8px;">Danh sách chứng thư số</p>
              <el-form :model="form" :rules="rules" ref="form">
                <el-form-item prop="cts">
                  <el-radio-group v-model="form.cts" class="ml-4"
                    style="display: flex; flex-direction: column; gap: 10px;">
                    <el-radio v-for="item in listCTS" :key="item.keyID" :label="item.keyID" size="large"
                      @change="changeCTS">{{ item.subjectDN }}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-form>
            </div>

          </div>
        </div>

      </template>

      <template #footer>
        <div class="flex-row flex__between">
          <div class="flex__right form-button__action">
            <el-button type="success" size="mini" class="addDocs btn-none__border color__white bg__blue" @click="save"
              :disabled="isUploading || isSubmitting">
              <span class="flex-row flex__center">
                <i :class="[
                  !isUploading && !isSubmitting
                    ? 'fas fa-save'
                    : 'el-icon-loading',
                ]"></i>
                &nbsp;&nbsp;Xác nhận
              </span>
            </el-button>
            <el-button type="info" size="mini" class="btn__cancel btn-none__border" @click="cancel">
              <span class="flex-row flex__center">
                <i class="far fa-times-circle font-size__medium"></i>
                &nbsp;&nbsp;Hủy
              </span>
            </el-button>
          </div>
        </div>
      </template>
    </dialogTemplate>
  </div>
</template>

<script>
import dateFormatter from "../../../filters/dateFormatter";
import attachmentService from "../../../services/attachmentService";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";

export default {
  name: "dialog-change-password",
  mixins: [handleRequestErrorMixin],
  props: ["isOpen", "isSubmitting"],
  filters: { dateFormatter },
  components: {
    dialogTemplate: () => import("../custom-dialog.vue"),
  },
  data() {
    return {
      isUploading: false,
      user: {},
      form: {
        username: null,
        password: null,
        cts: null
      },
      oldPasswordError: false,
      rules: {
        username: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: "Trường dữ liệu bắt buộc",
            trigger: "blur",
          },
        ],
      },
      listCTS: [],
      requestSignVb: null,
    };
  },

  methods: {
    cancel() {
      this.$emit("closeDialog");
    },

    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) return;
        this.isUploading = true;
        let submitForm = {
          username: this.form.username,
          password: this.form.password,
        };
        // this.signVb(submitForm)
        //   .then(() => {
        //     this.isUploading = false;
        //     // this.oldPasswordError = true;
        //   });
        attachmentService.loginIntrustCA(submitForm)
          .then(res => {
            this.requestSignVb = res.data;
            attachmentService.getCertificates(res.data)
              .then(res1 => {
                this.listCTS = res1.data;
                if (this.listCTS.length === 1) {
                  this.requestSignVb.certificateKeyId = this.listCTS[0].keyID;
                  this.signVbAccessToken(this.requestSignVb)
                }
              })
          })
      });
    },

    changeCTS() {
      this.requestSignVb.certificateKeyId = this.form.cts
      this.signVbAccessToken(this.requestSignVb)
    },

    getCTSName(subjectDN) {
      return subjectDN.match(/CN=([^,]+)/)[1];
    },

    async signVb(submitForm) {
      await this.$emit("success", submitForm);
    },

    async signVbAccessToken(accessToken) {
      await this.$emit("success", accessToken);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/common/noteDocs/LoginIntrust.vue